import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

class UserPinService {
  // Felhasználó összes gombostűjének lekérdezése
  async getUserPins() {
    try {
      const response = await apiService.get(API_ENDPOINTS.USER_PINS.LIST);
      return response;
    } catch (error) {
      console.error('Felhasználói gombostűk lekérése hiba:', error);
      throw error;
    }
  }

  // Új gombostű létrehozása
  async createUserPin(pinData) {
    try {
      const response = await apiService.post(API_ENDPOINTS.USER_PINS.CREATE, pinData);
      return response;
    } catch (error) {
      console.error('Gombostű létrehozása hiba:', error);
      throw error;
    }
  }

  // Gombostű frissítése
  async updateUserPin(pinId, pinData) {
    try {
      const response = await apiService.put(API_ENDPOINTS.USER_PINS.UPDATE(pinId), pinData);
      return response;
    } catch (error) {
      console.error('Gombostű frissítése hiba:', error);
      throw error;
    }
  }

  // Gombostű törlése
  async deleteUserPin(pinId) {
    try {
      const response = await apiService.delete(API_ENDPOINTS.USER_PINS.DELETE(pinId));
      return response;
    } catch (error) {
      console.error('Gombostű törlése hiba:', error);
      throw error;
    }
  }
}

export default new UserPinService();